import { isValidPhoneNumber } from "react-phone-number-input";

// Pragmatic RFC 5322-ish email check for form validation.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const isValidEmail = (value) => EMAIL_RE.test((value || "").trim());

// Phone values from PhoneInput are E.164 (e.g. +237677123456).
export const isValidPhone = (value) => {
  if (!value) return false;
  try { return isValidPhoneNumber(value); } catch { return false; }
};

export { isValidPhoneNumber };
